export enum AddToBagErrors {
    ITEM_QTY_MAXIMUM_REACHED = 'ITEM_QTY_MAXIMUM_REACHED'
}
